import React, { useEffect, useState } from 'react'
import ErrorMessage from '../../../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../../../UI/form/MyButton'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../../../../helpers/form/FormHelper'
import { useDispatch } from 'react-redux'
import { responseError } from '../../../../../../../helpers/response/ResponseHelper'
import ReceivedSelect from './fields/ReceivedSelect'
import { editSupplyOrderItemReceivedAPI } from '../../../../../../../api/supply/supplyOrderItemAPI'
import { editSupplyOrderItem } from '../../../../../../../store/supplyOrderSlice'
import ReceivedCountField from './fields/ReceivedCountField'

const ChangeReceivedForm = ({ supplyOrderItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        supplyOrderItemBd ? 
            {
                isReceived: supplyOrderItemBd.isReceived,
                countReceived: supplyOrderItemBd.countReceived,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editSupplyOrderItemReceivedAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editSupplyOrderItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: supplyOrderItemBd.id,
            isReceived: data.isReceived,
            countReceived: data.countReceived,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('isReceived', 'supplyOrderItem') ?
				<ReceivedSelect
					required={formDataProductRequiredField('isReceived', 'supplyOrderItem')}
					setValidate={e => updateValidate(setValid, 'isReceived', e)}
					setValueForm={e => setValueForm(setData, 'isReceived', e)}
					forciblyValue={data && data.isReceived ? data.isReceived : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('countReceived', 'supplyOrderItem') ?
				<ReceivedCountField
                    item={supplyOrderItemBd}
					required={formDataProductRequiredField('countReceived', 'supplyOrderItem')}
					setValidate={e => updateValidate(setValid, 'countReceived', e)}
					setValueForm={e => setValueForm(setData, 'countReceived', e)}
					forciblyValue={data && data.countReceived ? data.countReceived : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangeReceivedForm